import React from 'react';
import { ErrorMessage, Field } from 'formik';
import Select from 'react-select';
import useFieldDecorators from '../hooks/useFieldDecorators';
import Label from '../common/Label';
/**
 * A multi-select input. Allows user to search for and select multiple values
 * @param props.options - The options to present in the select dropdown
 * @param props.selectedOptions - Any options that should show up as pre-selected
 * @param props.onChange - A custom onChange method, called with an array of values of the options that were selected
 * @param props.selectProps - The properties to pass to the underlying react-select component
 */
const MultiSelectField = (props) => {
    const { isRequired, helpBlock, contentCssClass, labelCssClass, fieldCssClass } = useFieldDecorators(props);
    return (React.createElement("div", { className: "form-group row" },
        React.createElement(Label, { name: props.name, label: props.label, tooltipText: props.tooltip, labelCssClass: labelCssClass, isRequired: isRequired }),
        React.createElement("div", { className: contentCssClass },
            React.createElement(Field, { type: "select", name: props.name }, (fieldProps) => (React.createElement(Select, Object.assign({ id: props.name, styles: {
                    control: (styles) => {
                        if (fieldCssClass.includes('is-invalid')) {
                            return Object.assign(Object.assign({}, styles), { borderColor: '#dc3545' });
                        }
                        return styles;
                    },
                }, name: props.name, onChange: (optionArray) => {
                    const optionValues = optionArray
                        ? optionArray.map((option) => option.value)
                        : [];
                    if (props.onChange) {
                        props.onChange(optionValues);
                    }
                    fieldProps.form.setFieldValue(props.name, optionValues);
                }, onBlur: () => fieldProps.form.setFieldTouched(props.name, true), defaultValue: props.selectedOptions, options: props.options, isMulti: true, "data-testid": props.testId, inputId: props.name }, props.selectProps)))),
            React.createElement(ErrorMessage, { name: props.name, className: "text-danger", component: "small" }),
            helpBlock)));
};
export default MultiSelectField;
